;(function(){

	$('.js-scroll').on('click', function(e) {
		var $target = $($(this).attr('href'));

		if (!$target.length) {
			return;
		}

		e.preventDefault();

		TweenLite.to(window, 2, {
			scrollTo: {
				y: $target.offset().top,
			},
			ease: Expo.easeOut,
		});
	});

}());
